// tweaks with services
import overlapBlock from "./overlapBlock";
import spaceBlock from "./space-block";
import expandBlock from "./expander"; // function changeArticlesStructure() {
//     $('.articles:not(".mindset")').each(function () {
//         let titles = $(this).find('.equal-height h3');
//
//         titles.each(function () {
//
//             $(this).parents(".item").find("p").outerHeight(179 - $(this).height());
//
//         });
//
//     })
// }

export default (function () {
  equalHeight();
}); // $(document).ready(() => {
// if (window.matchMedia('(min-width: 768px)').matches) {
//     setTimeout(function () {
//         changeArticlesStructure();
//     }, 500)
//
// }
// });
// $(window).resize(function () {
// if (window.matchMedia('(min-width: 768px)').matches) {
//     changeArticlesStructure();
// }
// });
// $(document).ajaxComplete(function () {
// if (window.matchMedia('(min-width: 768px)').matches) {
//     changeArticlesStructure();
// }
// });

export function equalHeight() {
  var blocks = $('.js-equal-wrap');
  blocks.each(function () {
    var titles = $(this).find('h3');
    var highestTitle = 0;
    titles.each(function () {
      $(this).height('auto');

      if ($(this).outerHeight() > highestTitle) {
        highestTitle = $(this).outerHeight();
      }
    });
    titles.outerHeight(highestTitle);
    var elements = $(this).find('.js-equal-height');
    var highestBox = 0;
    elements.each(function () {
      $(this).height('auto');

      if ($(this).outerHeight() > highestBox) {
        highestBox = $(this).outerHeight();
      }
    });

    if ($(this).parent().parent().hasClass("tiles-block")) {
      if (window.matchMedia('(min-width: 1024px)').matches) {
        elements.outerHeight(highestBox);
      }
    } else {
      elements.outerHeight(highestBox);
    }

    if (window.matchMedia('(min-width: 1024px)').matches) {
      var image = $(this).find('.js-equal-image');
      var block = $(this).find('.js-equal-block');
      image.innerHeight(block.height() - highestBox - 42);
    }
  });
} // icon list block

function iconListBlock() {
  if (window.matchMedia('(max-width: 767px)').matches) {
    $(".icon-list-block .icon-list-button").removeClass("js-equal-height");
    $(".icon-list-block").find('.icon-list-button__title').css('height', 'auto');
  } else {
    $(".icon-list-block .icon-list-button").addClass("js-equal-height");
    $(".icon-list-block").each(function () {
      var elements = $(this).find('.icon-list-button__title');
      var highestTitle = 0;
      elements.each(function () {
        if ($(this).outerHeight() > highestTitle) {
          highestTitle = $(this).outerHeight();
        }
      });
      elements.outerHeight(highestTitle);
      elements.each(function () {
        if ($(this).outerHeight() < highestTitle) {
          var text = $(this).text(),
              textTrimmed = text.trim(),
              firstPart = textTrimmed.split(" ").reverse().slice(1).reverse().join(" "),
              secondPart = textTrimmed.split(" ").splice(-1)[0];

          if (firstPart.length) {
            $(this).html(firstPart + '<br>' + secondPart);
          }
        }
      });
    });
  }
}

function tableElement() {
  setTimeout(function () {
    if (window.matchMedia('(max-width: 767px)').matches) {
      $(".table-card--image").each(function () {
        var imgHeight = $(this).find('img').height();
        console.log(imgHeight);
        $(this).css('margin-top', imgHeight - 32);
      });
    } else {
      $(".table-element").each(function () {
        var elements = $(this).find('.table-card--image');
        var highestImgHeight = 0;
        elements.each(function () {
          if ($(this).find('img').height() > highestImgHeight) {
            highestImgHeight = $(this).find('img').height();
          }
        });
        $(this).css('padding-top', highestImgHeight + 100 - 32);
      });
    }
  }, 500);
}

$(document).ready(function () {
  equalHeight();
  tableElement();
  iconListBlock();
});
$(".page-slider_2").on("init", function (event, slick) {
  equalHeight();
});
$(window).on('resize orientationchange', function () {
  setTimeout(function () {
    equalHeight();
  }, 500);
  iconListBlock();
});